import {Button, Form, Input, Modal, Spin, Switch, Table} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useForm} from "antd/es/form/Form";

const Categories = () => {
    const {t} = useTranslation();
    const [categories, setCategories] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editData, setEditData] = useState(null);
    const [form] = useForm();

    useEffect(() => {
        if (!isModalOpen) {
            form.resetFields();
            setEditData(null);
        }
    }, [isModalOpen])

    const getCategories = () => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}/admin/category/get-categories`,
                {
                    withCredentials: true,
                }
            )
            .then((response) => {
                const {data} = response.data;
                setCategories(data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getCategories()
    }, []);

    const updateStatus = async (id, isActive) => {
        try {
            setLoading(true);
            axios
                .put(
                    `${process.env.REACT_APP_API_URL}/admin/category/${id}/update-category-status`,
                    {
                        isActive
                    },
                    {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    setLoading(false);
                    getCategories();
                    setIsModalOpen(false);
                })
                .catch((error) => {
                    setLoading(false);
                });
        } catch (errorInfo) {
            setLoading(true);
            // Handle validation errors
            console.log("Validation failed:", errorInfo);
        }
    };

    const handleOk = async () => {
        await form.validateFields();
        const formData = form.getFieldsValue();
        try {
            setLoading(true);
            if (editData) {
                axios
                    .put(
                        `${process.env.REACT_APP_API_URL}/admin/category/update-category`,
                        {
                            categoryName: formData.title,
                            categoryId: editData.key
                        },
                        {
                            withCredentials: true,
                        }
                    )
                    .then((response) => {
                        setLoading(false);
                        getCategories();
                        setIsModalOpen(false);
                        setEditData(null);
                    })
                    .catch((error) => {
                        setLoading(false);
                    });
            } else {
                axios
                    .post(
                        `${process.env.REACT_APP_API_URL}/admin/category/add-category`,
                        {
                            name: formData.title
                        },
                        {
                            withCredentials: true,
                        }
                    )
                    .then((response) => {
                        setLoading(false);
                        getCategories();
                        setIsModalOpen(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                    });
            }
        } catch (errorInfo) {
            setLoading(true);
            // Handle validation errors
            console.log("Validation failed:", errorInfo);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setEditData(null);
    };

    const categoriesData = [...categories]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map(item => {
            return {
                key: item._id,
                name: item.name,
                isActive: item.isActive,
            };
        });

    return <>
        <div className={'flex gap-4 items-center justify-end mb-3'}>
            <Button type="primary" className="text-white bg-blue-500"
                    onClick={() => setIsModalOpen(true)}>{t("Add new category")}</Button>
        </div>
        <Spin spinning={loading}>
            <Table columns={[
                {
                    title: 'Category',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: 'Active',
                    dataIndex: 'isActive',
                    key: 'isActive',
                    render: (text, record) => {
                        return <Switch onChange={(checked) => {
                            updateStatus(record.key, checked);
                        }} title={'Active'} checked={text}/>
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    render: (text, record) => (
                        <span>
          <Button type="primary" className="text-white bg-blue-500"
                  onClick={() => {
                      form.setFieldsValue({
                          title: record.name
                      });
                      setIsModalOpen(true);
                      setEditData(record);
                  }}>Edit</Button>
        </span>
                    ),
                },
            ]} dataSource={categoriesData}/>
        </Spin>

        <Modal
            width={400}
            centered
            open={isModalOpen}
            onOk={handleOk}
            okType="default"
            okText="Save"
            cancelText="Cancel"
            onCancel={handleCancel}
        >
            <div className="flex space-y-6 flex-col ">
                <div>
                    <p className="font-bold text-xl text-[#001529]">
                        {editData ? t("Update category") : t("Add new category")}
                    </p>
                </div>
                <div className="">
                    <Form
                        form={form}
                        className="w-full mx-auto p-4"
                        layout="vertical"
                    >
                        <div className="flex flex-col">
                            <label htmlFor="title">{t("Category Name")}</label>
                            <Form.Item
                                name="title"
                                rules={[
                                    {required: true, message: t("Please enter a category Name")},
                                    {
                                        max: 50,
                                        message: t("Title must not exceed 50 characters"),
                                    },
                                ]}
                            >
                                <Input id="title" placeholder={t("Enter your category Name")}/>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
        </Modal>
    </>
}

export default Categories;
